/* -------------------------------------------------------------------------
   ChatBot service – thin wrapper around /ChatBot/Ask
--------------------------------------------------------------------------- */
import config from "../config";
import selectedEnvironment from "../env";

const API_URL = `${config[selectedEnvironment].API_URL}`;

/**
 * Ask the Chat-Bot anything.
 * @param {string} accountantId   – current client‐case (send empty string if N/A)
 * @param {string} question – user’s raw text
 * @param {string} token    – Bearer JWT
 * @returns   fetch Response  (caller usually .json() and grabs `.answer`)
 */
const askQuestion = async (accountantId, question, token) => {
  return fetch(`${API_URL}/ChatBot/Ask`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ accountantId, question }),
  });
};

const ChatBotService = { askQuestion };
export default ChatBotService;
